export const SLOT = {
  COCKPIT:    'cockpit',
  WING_L:     'wing_left',
  WING_R:     'wing_right',
  ENGINE_L:   'engine_left',
  ENGINE_R:   'engine_right',
  NOSE:       'nose',
  WEAPON_TOP: 'weapon_top',
  MUZZLE_TOP: 'muzzle_top',
  EXHAUST_L:  'exhaust_left',
  EXHAUST_R:  'exhaust_right',
  WINGTIP_L:  'wingtip_left',
  WINGTIP_R:  'wingtip_right',
} as const;
